module.exports = __webpack_public_path__ + "static/media/logo1.6ff65b07.svg";